import readFileAsDataUrl from 'src/core/CoreFilePicker/functions/readFileAsDataUrl'

describe('readFileAsDataUrl', () => {
  test('Тогда возвращает Promise', () => {
    const file = new File(['content'], 'test.jpg', { type: 'image/jpeg' })
    const result = readFileAsDataUrl(file)

    expect(result).toBeInstanceOf(Promise)
  })

  test('Тогда разрешается с base64 строкой', async () => {
    const file = new File(['test content'], 'test.jpg', { type: 'image/jpeg' })
    const result = await readFileAsDataUrl(file)

    expect(result).toBe('data:image/jpeg;base64,dGVzdCBjb250ZW50')
  })
})
